import React from "react";
import { Container } from "@mui/material";
import { useWorkflowsBuilderPageView } from "../WorkflowsBuilderPage.context";
import { useSmsCampaignBuilder } from "./useSmsCampaignBuilder";
import SmsHeader from "./SmsHeader";
import DetailsStep from "./DetailsStep";
import MessageStep from "./MessageStep";

const SmsCampaignBuilder = () => {
  const { smsBuilderOpen, currentNodeId } = useWorkflowsBuilderPageView();
  if (!smsBuilderOpen) {
    return <></>;
  }
  return <SmsCampaignBuilderContent id={currentNodeId || ""} />;
};

export default SmsCampaignBuilder;

const SmsCampaignBuilderContent = ({ id }: { id: string }) => {
  const {
    step,
    goToStep,
    smsText,
    setSmsText,
    senderNumberId,
    setSenderNumberId,
    smsAccount,
    numbers,
    numbersLoading,
    calculation,
    calculationLoading,
    senderNumber,
    messageValid,
    senderVerified,
    handleDone,
  } = useSmsCampaignBuilder(id);

  return (
    <Container
      sx={(theme) => ({
        position: "fixed",
        m: 0,
        p: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: theme.palette.grey[20],
        minWidth: "100vw",
        minHeight: "100vh",
        zIndex: 10,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      })}
      disableGutters
    >
      <SmsHeader
        step={step}
        onStepClick={goToStep}
        onNext={() => goToStep("message")}
        onDone={handleDone}
        nextDisabled={!senderVerified}
        doneDisabled={!messageValid}
      />
      <div style={{ flex: "1 1 auto", overflowY: "auto", overflowX: "hidden" }}>
        {step === "details" && (
          <DetailsStep
            numbers={numbers}
            numbersLoading={numbersLoading}
            smsAccount={smsAccount}
            senderNumberId={senderNumberId}
            onSelectSender={setSenderNumberId}
          />
        )}
        {step === "message" && (
          <MessageStep
            smsText={smsText}
            onChange={setSmsText}
            calculation={calculation}
            calculationLoading={calculationLoading}
            senderNumber={senderNumber}
          />
        )}
      </div>
    </Container>
  );
};
